import React, {useState, useContext} from "react";
import {useTranslation, withTranslation} from "react-i18next";
import Spinner from "../../../UI/Spinner";
import { useForm, useWatch } from "react-hook-form";
import {toast} from "react-toastify";
import axios from "../../../../axios-defaults";

import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import Alert from "../../../UI/Alerts/Alert";
import UserContext from '../../../../context/user-context';

registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileEncode);



const Form = (props) => {


    const {transactionStatus: {code}} = props.invoice
    const {t, i18n} = useTranslation();
    const userContext = useContext(UserContext);

    const { register, handleSubmit, watch, control, formState: { errors } } = useForm({
        defaultValues: {
            title: t('invoice_review.title')+' (#'+props.invoice.invoiceNumber+')',
            reasons: [],
            description: '',
            file: {}
        }
    });

    const reasonsChecked = useWatch({
        control,
        name: "reasons",
    });

    const reasonsCheckboxes = [
        {
            value: 'po',
            label: t('invoice_review.form.reason.po'),
            desc: t('invoice_review.form.reason.po_text'),
        },
        {
            value: 'date',
            label: t('invoice_review.form.reason.date'),
            desc:  t('invoice_review.form.reason.date_text'),
        },
        {
            value: 'subaccount',
            label: t('invoice_review.form.reason.sub_account'),
            desc: t('invoice_review.form.reason.sub_account_text'),
        },
        {
            value: 'product',
            label: t('invoice_review.form.reason.product'),
            desc: t('invoice_review.form.reason.product_text'),
        },
        {
            value: 'price',
            label: t('invoice_review.form.reason.price'),
            desc: t('invoice_review.form.reason.price_text'),
        },
        {
            value: 'tax',
            label: t('invoice_review.form.reason.tax'),
            desc: t('invoice_review.form.reason.tax_text'),
        },
        {
            value: 'fees',
            label: t('invoice_review.form.reason.fees'),
            desc: t('invoice_review.form.reason.fees_text'),
        },

        {
            value: 'incorrect_customer',
            label: t('invoice_review.form.reason.incorrect_customer'),
            desc: t('invoice_review.form.reason.incorrect_customer_text'),
        }
    ];


    const getReasonObj = (reason) => {
        const [values] = reasonsCheckboxes.filter(el => el.value === reason);
        return values;
    }

    let modalContent = '';

    const [loading, setLoading] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [formValues, setFormValues] = useState({});

    const [enteredReasons, setEnteredReasons] = useState(reasonsCheckboxes);
    // const [reasonsListChecked, setReasonsListChecked] = useState([]);
    const [enteredComment, setEnteredComment] = useState(null);
    const [enteredFile, setEnteredFile] = useState([]);
    const [fileReader,setFileReader] = useState([]);
    const [ticketNumber,setTicketNumber] = useState();
	const [files, setFiles] = useState([]);


    const enteredCommentHandler = (event) => {setEnteredComment(event.target.value);}

    const onSubmitHandler = async (data) => {
		setLoading(true);
		let allReasons = [];
		let allFiles = [];

		files.forEach((file) => {
			if (file.fileType === 'application/pdf' ||
				file.fileType === 'application/msword' ||
				file.fileType === 'image/png' ||
				file.fileType === 'image/jpeg' ||
				file.fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
				let render = file.getFileEncodeBase64String();
				let fileinfos = {
					'path':file.filename,
					'base64':`data:${file.fileType};base64,${render}`
				}

				allFiles.push(fileinfos);
			}
		})

        data.file = allFiles;
        setFormValues({...data})

        data.reasons.map(reason => {
            let {label} = getReasonObj(reason);
            allReasons.push(label)
        })

        data.description = `Nom: ${userContext.user.infos.firstname} ${userContext.user.infos.lastname}\r\nCourriel: ${userContext.user.infos.email}\r\nRaisons: ${allReasons.toString()} ${data.description ? '\r\nDescription: ' + data.description : '' }`

        axios.post(`/dataverse/incidents/create`, data)
            .then(response => {
                if (response.data.succeeded) {
                    setLoading(false);
                    setConfirmation(true);
                    setTicketNumber(response.data.ticket_number)
                } else {
					toast.error(
						<div>
							<i className="fal fa-exclamation-circle"></i>&nbsp;{response.data.message}
						</div>
					);
				}
                setLoading(false);
            }).catch(error => {
				toast.error(
					<div>
						<i className="fal fa-exclamation-circle"></i>&nbsp;{error.message}
					</div>
				);
            	console.log('[Form.js] : Communications ajax error in onSubmitHandler()', error.message)
            	setLoading(false);
        });
    }

    if (!loading && !confirmation) {
        modalContent =
            <form className="invoice-review-form flex flex--direction-column form form--invoice-review"
                  onSubmit={handleSubmit(onSubmitHandler)}>
                <div className="section-separator">
                    <h2 className="h2">
                        {t('invoice_review.form.reason.title')} <strong className="strong strong--c-red">*</strong>
                    </h2>

                    <p>{t('invoice_review.form.reason.text')}</p>

                    <div className="input-field input-field--checkbox">
                        <ul className="checkbox-field-wrapper">
                            {enteredReasons.map(({value, label, checked}, key) => {
                                return (
                                    <li key={`reasons-${value}`}>
                                        <label className="checkbox-field checkbox-field--gray mb-3 pl-1 mt-2"
                                               htmlFor={value}>
                                            <input type="checkbox"
                                                   key={key}
                                                   data-key={key}
                                                   id={value}
                                                   value={value}
                                                   {...register('reasons', {
                                                       required: true,
                                                   })}
                                            />
                                            <span></span>
                                            &nbsp;{label}
                                        </label>
                                    </li>
                                );
                            })}
                        </ul>
                        {errors.reasons && <p className="error">{t("errors.fieldrequired")}</p>}
                    </div>

                    { (reasonsChecked.length > 0) &&
                        <div className="invoice-review-form__reasons-message message message--warning">
                            <div className="message__icon">
                                <i className="fas fa-exclamation-triangle"></i>
                            </div>
                            <div className="message__content">
                                <strong>
                                    {t("invoice_review.form.reason.text_message")}
                                </strong>

                                <ul>
                                    {reasonsChecked.map(reason => {
                                        let {value, label, desc} = getReasonObj(reason);
                                        return (
                                            <li key={`reasons-desc-${value}`}>
                                                {`${label} : ${desc}`}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    }
                </div>

                <div className="section-separator">
                    <h2 className="h2">{t('invoice_review.form.comment.title')}</h2>
                    <label className="input-field input-field--textarea">
                        <textarea
                            className="_full"
                            name="comment"
                            id="comment"
                            cols="30"
                            rows="10"
                            onChange={enteredCommentHandler}
                            {...register('description')}
                        ></textarea>
                    </label>
                </div>
                {/*
                <div>
                    <h2 className="h2">{t('invoice_review.form.file.title')}</h2>
                    <div className="input-field input-field--file">
						<FilePond
							files={files}
							allowFileEncode
							allowFileTypeValidation
							onupdatefiles={setFiles}
							allowMultiple={true}
							dropOnPage={true}
							labelFileTypeNotAllowed={t('invoice_review.form.file.rejected_file')}
							fileValidateTypeLabelExpectedTypes={`${t('invoice_review.form.file.expected_file')} {allButLastType}`}
							acceptedFileTypes={["application/pdf", "application/msword",  "image/png", "image/jpeg", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]}
							instantUpload={false}
							name="files"
							// stylePanelLayout={'integrated'}
							labelIdle={`
								<div class="message message--filepond">
									<div class="message__icon">
										<i class="fal fa-cloud-upload fa-3x"></i>
									</div>
									<div class="message__content">
										<p class="p p--uppercase mb-1">
											<strong>${t('invoice_review.form.file.dropzone_text')}</strong>
										</p>
										<p>${t('invoice_review.form.file.accepted_text')}</p>
									</div>
								</div>
							`}
						/>
					</div>
				</div>
                */}

                {code === 'P' &&
                    <div className="mt-4">
                        <div className="message message--danger">
                            <div className="message__icon">
                                <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            </div>
                            <div className="message__content d-block">
                                <p className="p p--fs-18 p--c-red">
                                    <strong>
                                        {t('invoice_review.message')}
                                    </strong>
                                </p>
                            </div>
                        </div>
                    </div>
                }

                <div className="flex flex--justify-end flex--gap--3 mt-5">
                    <button type="button"
                            className="btn btn--raised btn--raised--white"
                            onClick={props.clickCancel}>
                        {t('invoice_review.form.cancel')}
                    </button>
                    <button type="submit"
                            className="btn btn--raised btn--raised--red">
                        {t('invoice_review.form.submit')}
                    </button>
                </div>

            </form>

    } else if(!loading && confirmation) {
        modalContent =
            <div>
                <div className="invoice-review-confirmation">
                    <h2 className="h2 mb-4">{t('invoice_review.confirmation.title')} {`#${ticketNumber}`}</h2>
                    <div className="flex flex--gap--1">
                        <strong>{t('invoice_review.confirmation.reasons')} </strong>

                        <ul className="invoice-review-confirmation__list flex">
                            {reasonsChecked.map(reason => {
                                let {value, label} = getReasonObj(reason);
                                return (
                                    <li className="invoice-review-confirmation__item" key={`reason-${value}`}>
                                        {label}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    {formValues.description &&
                        <div>{formValues.description}</div>
                    }

                    {formValues.file.length > 0 &&
                        <div>
                            {files.map((item, index) => (
								(item.fileType === 'application/pdf' || item.fileType === 'application/msword' || item.fileType === 'image/png' || item.fileType === 'image/jpeg' || item.fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') &&
									<div key={index} className="message message--file">
										<div className="message_icon">
											<i className="far fa-file"></i>
										</div>
										<div className="message_content">
											<span>{item.filename}</span>
										</div>
									</div>
                            ))}
                        </div>
                    }

                </div>

				<Alert type="info" item={{
					type: 'info',
					additionalClasses: 'mt-3 mb-3',
					customIcon: 'fas fa-clock',
					text: t('invoice_review.10days_notice')
				}}/>

                <div className="flex flex--justify-end flex--gap--3 mt-5">
                    <button type="button"
                            className="btn btn--raised btn--raised--red"
                            onClick={props.clickCancel}>
                        {t('invoice_review.confirmation.close')}
                    </button>
                </div>

			</div>

    } else {
        modalContent = <Spinner/>;
    }

    return(
        <div>
            {modalContent}
        </div>
    );
}

export default Form;
